import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Placeholder,
  Row,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { EmpresaBuscarPorUsuario } from "src/services/Entidade.Service";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../NFe.Dto";

const NFeCadastroDestinoOperacaoView = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const destinoOperacaoSelecionado = () =>
    getLocal<NFeDto>(STORAGENFE_KEY)?.destinoOperacao ?? undefined;

  const [destinoOperacao, setDestinoOperacao] = useState<number | undefined>(
    () => destinoOperacaoSelecionado()
  );

  useEffect(() => {
    const sugerirDestinoOperacao = async () => {
      const nf = getLocal<NFeDto>(STORAGENFE_KEY);

      // Se já existir algo salvo no localstorage, aplica como preferência
      if (nf?.destinoOperacao !== undefined) {
        setDestinoOperacao(nf.destinoOperacao);
        setLoading(false);
        return;
      }

      // Caso contrário, calcula a sugestão com base na comparação das UFs
      try {
        let ufEmpresa = sessionStorage.getItem("empresa_uf");
        if (!ufEmpresa) {
          const response = await EmpresaBuscarPorUsuario();
          if (response.data.success && response.data.data?.uf) {
            const uf = String(response.data.data.uf);
            ufEmpresa = uf;
            sessionStorage.setItem("empresa_uf", uf);
          }
        }

        const ufDestinatario = nf?.destinatario?.uf;

        if (ufEmpresa && ufDestinatario) {
          const ufEmpresaNorm = ufEmpresa.trim().toUpperCase();
          const ufDestinatarioNorm = ufDestinatario.trim().toUpperCase();

          const sugestao = ufEmpresaNorm === ufDestinatarioNorm ? 1 : 2;

          updateLocal<NFeDto>(STORAGENFE_KEY, {
            destinoOperacao: sugestao,
          });
          setDestinoOperacao(sugestao);
        } else {
          setDestinoOperacao(undefined);
        }
      } catch (error) {
        console.error(
          "Erro ao verificar UF da empresa para destino da operação:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    sugerirDestinoOperacao();
  }, []);

  const selecionado = destinoOperacao !== undefined;

  const handleSalvar = (tipo: number) => () => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      destinoOperacao: tipo,
    });
    setDestinoOperacao(tipo);
    navigate("../item");
  };

  const handleVoltar = () => () => {
    navigate("../consumidorfinal");
  };

  const handleProximo = () => {
    navigate("../item");
  };

  const buttonVariant = (operacao: number) => {
    if (destinoOperacao === operacao) {
      return "primary";
    }

    return "outline-primary";
  };

  return (
    <>
      {!loading ? (
        <>
          <Row>
            <Col xs={12} className="d-grid mt-3">
              <Button
                type="submit"
                onClick={handleSalvar(1)}
                variant={buttonVariant(1)}
              >
                1 - Interna
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-grid mt-3">
              <Button
                type="submit"
                onClick={handleSalvar(2)}
                variant={buttonVariant(2)}
              >
                2 - Interestadual
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-grid mt-3">
              <Button
                type="submit"
                onClick={handleSalvar(3)}
                variant={buttonVariant(3)}
              >
                3 - Exterior
              </Button>
            </Col>
          </Row>
          <div className="fixed-bottom">
            <Container className="py-3">
              <Row>
                <Col xs={!selecionado ? 12 : 6} className="d-grid">
                  <Button variant="outline-secondary" onClick={handleVoltar()}>
                    Voltar
                  </Button>
                </Col>
                {selecionado && (
                  <Col xs={6} className="d-grid">
                    <Button
                      variant="outline-primary"
                      type="submit"
                      onClick={handleProximo}
                    >
                      Próximo
                    </Button>
                  </Col>
                )}
              </Row>
            </Container>
          </div>
        </>
      ) : (
        <Placeholder as={FloatingLabel} animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </>
  );
};
export default NFeCadastroDestinoOperacaoView;
